export const locale = {
  lang: 'en-CA',
  data: {
    QUICK_ORDER: {
      TITLE: 'New Pickup',
      CLIENTS_TITLE: 'Clients',
      BY_CLIENT: 'Filter by client',
      BY_ENTERPRISE: 'Filter by enterprise',
      ORDERING_CLIENT: 'Ordering client',
      INVOICING_CLIENT: 'Invoicing client',
      SAME_CLIENT_BOTH: 'Use the same client for ordering and invoicing',
      COPY_START_DATE: 'Copy the start date',
    },
  },
};
